import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  checkType(obj: any): string {
    const objType = Object.prototype.toString.call(obj);
    return objType.match(/\[object (.*?)\]/)[1].toLowerCase();
  }

  transKeys(data, format) {
    if (this.checkType(data) === 'array') {
      data.forEach((d) => {
        this.transKeys(d, format);
      });
    } else if (this.checkType(data) === 'object') {
      Object.entries(data).forEach(([key, value]) => {
        this.transKeys(value, format);
        const newKey = this.transFormat(key, format); // 转换key的格式
        if (newKey !== key) {
          data[newKey] = value;
          Reflect.deleteProperty(data, key);
        }
      });
    }
    return data;
  }

  transFormat(value: string, format: string) {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    const chinesePattern = /[\u4e00-\u9fa5]/;
    // 如果字符串匹配电子邮件、日期格式或包含中文字符，则直接返回原字符串
    if (emailPattern.test(value) || datePattern.test(value) || chinesePattern.test(value)) {
      return value;
    }
    if (format === 'camelCase') {
      return _.camelCase(value);
    } else if (format === 'snakeCase') {
      return _.snakeCase(value);
    } else {
      return value;
    }
  }

  // 复制文本
  copyText(text: string) {
    const textarea = document.createElement('textarea');
    document.body.appendChild(textarea);
    // 隐藏此输入框
    textarea.style.position = 'fixed';
    textarea.style.top = '-100px';
    textarea.style.left = '-100px';
    textarea.style.opacity = '0';
    textarea.style.width = '0';
    textarea.style.height = '0';
    // 赋值
    textarea.value = text;
    // 选中
    textarea.select();
    // 复制
    document.execCommand('copy', true);
    // 移除输入框
    document.body.removeChild(textarea);
    // }
  }

  // base64 转 Blob
  base64ToBlob(base64) {
    let arr = base64.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
}
